<template>
	<vs-table
		:hoverFlat="true"
		:notSpacer="true"
		:data="subTransactions"
	>
		<template slot-scope="{data}">
			<vs-tr
				:data="subTransactions"
				:key="index"
				v-for="(subTransaction, index) in data"
			>
				<vs-td>
					<vs-checkbox
						v-model="selectedTransactions"
						:vs-value="subTransaction.id"
					></vs-checkbox>

				</vs-td>
				<vs-td :data="subTransaction.code">
					{{ subTransaction.code }}
				</vs-td>
				<vs-td :data="subTransaction.customer ? subTransaction.customer.displayName : ''">
					{{ subTransaction.customer ? subTransaction.customer.displayName : '' }}
					<br>
					<small>
						{{ subTransaction.contact ? '(' + subTransaction.contact.fullName + ')' : '' }}
					</small>
				</vs-td>
				<vs-td :data="subTransaction.client ? subTransaction.client.displayName : ''">
					{{ subTransaction.client ? subTransaction.client.displayName : '-' }}
				</vs-td>
				<vs-td :data="subTransaction.property ? subTransaction.property.fullAddress : ''">
					{{ subTransaction.property ? subTransaction.property.fullAddress : '' }}
					<br>
					<small>
						HRSZ: {{ subTransaction.property ? subTransaction.property.parcelNumber : '' }}
					</small>
				</vs-td>
				<vs-td :data="subTransaction.transactionType ? subTransaction.transactionType.name : ''">
					{{ subTransaction.transactionType.parent ? subTransaction.transactionType.parent.name + ' / ' + subTransaction.transactionType.name : subTransaction.transactionType.name }}
				</vs-td>
				<vs-td :data="subTransaction.transactionNumber ? subTransaction.transactionNumber : ''">
					{{ subTransaction.transactionNumber ? subTransaction.transactionNumber : '' }}
				</vs-td>
				<vs-td :data="subTransaction.statusText ? subTransaction.statusText : ''">
					{{ subTransaction.statusText ? subTransaction.statusText : '' }}
				</vs-td>
				<vs-td :data="subTransaction.lastPhase ? subTransaction.lastPhase.phase.name : ''">
					<vs-chip :color="getStatusColor(subTransaction.lastPhase ? subTransaction.lastPhase.status : '')">
						{{ subTransaction.lastPhase ? (subTransaction.lastPhase.phase.name + ' - ' + subTransaction.lastPhase.statusText ) : 'Nincs' }}
					</vs-chip>
				</vs-td>
				<vs-td>
					<div class="flex pull-right">
						<vx-tooltip text="Módosítás">
							<vs-button
								class="btn-drop mr-2"
								type="border"
								icon-pack="feather"
								icon="icon-edit"
								size="medium"
								color="dark"
								@click.stop="editData(subTransaction)"
							></vs-button>
						</vx-tooltip>
						<vs-dropdown
							class="cursor-pointer"
							vs-custom-content
						>
							<vs-button
								class="btn-drop"
								type="border"
								icon-pack="feather"
								icon="icon-more-horizontal"
								size="medium"
							></vs-button>

							<vs-dropdown-menu class="pt-3 list-more">
								<ul style="min-width: 9rem">

									<li
										class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
										@click.stop="addPhase(subTransaction)"
									>
										<feather-icon
											icon="FolderPlusIcon"
											svgClasses="w-4 h-4"
										/>
										<span class="ml-2">Feladat hozzáadása</span>
									</li>

									<li
										class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
										@click.stop="addSubTransaction(subTransaction)"
									>
										<feather-icon
											icon="PlusIcon"
											svgClasses="w-4 h-4"
										/>
										<span class="ml-2">Alügylet létrehozása</span>
									</li>

									<vs-divider class="m-1" />

									<li
										class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
										@click.stop="deleteData(subTransaction.id)"
									>
										<feather-icon
											icon="Trash2Icon"
											svgClasses="w-4 h-4"
										/>
										<span class="ml-2">Törlés</span>
									</li>

								</ul>
							</vs-dropdown-menu>
						</vs-dropdown>
					</div>
				</vs-td>
			</vs-tr>
		</template>
	</vs-table>
</template>

<script>
export default {
	props: {
		subTransactions: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			chartOptions: null
		}
	},
	watch: {
	},
	computed: {
	},
	methods: {
		editData(data) {
			this.$emit('editData', data)
		},
		deleteData(id) {
			this.$emit('deleteData', id)
		},
		addPhase(id) {
			this.$emit('addPhase', id)
		},
		getStatusColor(status) {
			switch (status) {
				case 'in_progress':
					return 'warning'

				case 'done':
					return 'success'

				case 'obstacle':
					return 'danger'

				default:
					return 'dark'
			}
		}

	}
}
</script>
